import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { ShippingContent } from "@/features/dashboard/transportadoras/components/ShippingContent";

export const Route = createFileRoute("/_private/dashboard/_base/transportadoras/_forms/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Editar Transportadora" from="/dashboard/transportadoras/editar/$id">
      <ShippingContent />
    </BaseEditCreateModal>
  );
}
